import React from "react";
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    Avatar,
    Button, IconButton, Divider,
    TextField, List, ListItem, ListItemAvatar, ListItemText,
    Dialog, DialogTitle, DialogContent, Menu, MenuItem, Chip
} from "@material-ui/core";

import {arrayFilter, buildShapperPath, choiceImage, isResponsive, parserContent} from "../../../helpers/Tools";
import BreadCrumbs from "../../../components/BreadCrumbs";
import FlatList from 'flatlist-react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {compose} from 'redux';
import {withTranslation} from 'react-i18next';
import OpenItem from "../../../helpers/OpenItem";
import { useState } from "react";

import {baseApiUrl, uploadMediaStatic} from "../../../api/api";
import {store} from "../../../store/store";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBackward,
    faComment, faEllipsisV, faFile,
    faGrinHearts,
    faPaperPlane, faRulerVertical,
    faThumbsUp, faWindowClose, faPaperclip
} from "@fortawesome/free-solid-svg-icons";

import { faThumbsUp as faThumbsDownRegular, faWindowClose as faWindowCloseRegular } from '@fortawesome/free-regular-svg-icons';


import {FormulaireDynamicPicture} from "../../Formulaire/FormulaireDynamic/Formulaire.Dynamic.Picture";
import ImageUploader from "./ImageUploader";
import AttachmentUploader from "./AttachmentUploader";

const PostItem = ({tile, key, dataPage, fetchSocialPosts, handleNewPost, handleLike, handleOpen, handleClose, handleShowLikes, onUpdateState}) => {
    console.log("renderCategory");

    const [expanded, setExpanded] = useState(false);
    const [open, setOpen] = useState(false);
    const [openLikes, setOpenLikes] = useState(false);
    const [openFullImage, setOpenFullImage] = useState(false);

    const [comments, setComments] = useState([]);
    const [reactions, setReactions] = useState([]);
    const [commentText, setCommentText] = useState('');
    const [commentId, setCommentId] = useState(null);
    const [like, setLike] = useState('');

    let state = store.getState();

    handleClose = () => setOpen(false);
    const handleCloseLikes = () => setOpenLikes(false);

    let text = tile.content;


    let textFormated = text.replace(/(\r\n|\n|\r)/gm, "<br/>");
    //catch urls
    let regExUrl = /((https?:\/\/)|(www\.))([a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=]+)/gim;
    textFormated = textFormated.replace(regExUrl, function (url) {
        let newUrl = url;
        if (!url.startsWith("http")) {
            newUrl = "http://" + url;
        }
        return `<a href="${newUrl}" target="_blank">${url}</a>`;
    });

    //const prenomnom = tile.prenom + " " + tile.nom;
    const prenomnom = tile.author.firstname + " " + tile.author.lastname;
    //const timeAgo = tile.timeAgo;
    //"publish_date": "2025-03-24 12:09:00",
    const publish_date = tile.created_at;
    const date = new Date(publish_date);
    const timeAgo = date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });

    handleOpen = async () => {
        setOpen(true);
        try {
            const response = await fetch(baseApiUrl + '/getInteractionsByContentId', {
                method: 'POST', // Requête POST, comme dans le curl
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': tile.id, // ID du contenu
                    'offset': '0',
                    'limit': '100'
                })
            });

            const data = await response.json();

            if (!data.success) {
                throw new Error('Erreur lors de la récupération des commentaires');
            }


            const comments = data.result.comments;

            console.log("comments");
            console.log(comments);

            setComments(comments); // Assurez-vous que `data` contient les commentaires sous la forme attendue

        } catch (error) {
            console.error('Erreur lors du chargement des commentaires:', error);
        }
    };

    handleLike = async () => {
        setLike(true);
        try {
            const response = await fetch(baseApiUrl + '/setInteractionForContentId', {
                method: 'POST', // Méthode POST
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': tile.id, // ID du contenu
                    'type': 'reaction', // Type d'interaction
                    'value': tile.is_liked ? null : '👍🏼' // Valeur de l'interaction
                })
            });

            const data = await response.json();

            //refresh posts
            let posts = fetchSocialPosts();

            if (!data.success) {
                throw new Error('Erreur lors du like');
            }
        } catch (error) {
            console.error('Erreur lors du chargement des commentaires:', error);
        }
    };

    handleShowLikes = async () => {

        //on affiche comme pour les ocmmentaires
        setOpenLikes(true);
        try {
            const response = await fetch(baseApiUrl + '/getInteractionsByContentId', {
                method: 'POST', // Requête POST, comme dans le curl
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': tile.id, // ID du contenu
                    'offset': '0',
                    'limit': '100'
                })
            });

            const data = await response.json();

            if (!data.success) {
                throw new Error('Erreur lors de la récupération des commentaires');
            }


            const reactions = data.result.reactions_mobinautes;
            console.log("reactions");
            console.log(reactions);
            setReactions(reactions); // Assurez-vous que `data` contient les commentaires sous la forme attendue

        } catch (error) {
            console.error('Erreur lors du chargement des commentaires:', error);
        }

    };

    const handleSubmitComment = async (commentText) => {
        try {


            let bodyComment = {
                'appId': state.application.getApp.id,
                'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                'contentId': tile.id, // ID du contenu
                'type': 'comment', // Type d'interaction
                'value': commentText // Le texte du commentaire
            };

            //if edit
            if (commentId) {
                bodyComment.interactionId = commentId;
                bodyComment.type = 'updateComment';
            }


            const response = await fetch(baseApiUrl + '/setInteractionForContentId', {
                method: 'POST', // Méthode POST
                body: new URLSearchParams(bodyComment)
            });

            if (!response.ok) {
                throw new Error('Erreur lors de l\'envoi du commentaire');
            }



            const data = await response.json();
            console.log('Commentaire envoyé avec succès:', data);
            // Réinitialiser le champ de texte du commentaire
            setCommentText('');
            setCommentId(null);
            // Optionnellement, tu peux recharger les commentaires après avoir ajouté un nouveau commentaire
            handleOpen(); // Récupère les nouveaux commentaires après l'envoi
            //refresh posts
            let posts = fetchSocialPosts();
        } catch (error) {
            console.error('Erreur lors de l\'envoi du commentaire:', error);
        }
    };

    console.log("tile");
    console.log(tile);

    const handleImageClick = () => {
        setOpenFullImage(true);
    };

    const handleImageClose = () => {
        setOpenFullImage(false);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleOptionPostClose = () => {
        setAnchorEl(null);
    };
    const handleOptionPostEdit = (tile) => {
        handleOptionPostClose();
        //open edit post form
        console.log("handleOptionPostEdit");
        console.log(tile);


        onUpdateState({
            openNewPost: true,
        });
        if(tile) {
            onUpdateState({
                openNewPost: true,
                post_id: tile.id,
                post_title: tile.title,
                post_message: tile.content,
                post_keywords: tile.keywords,
                post_image: tile.media_url,
                post_file: tile.file_url,
            });
        }


/*
        setStateComponent({
            openNewPost: true
        });
        if(tile) {
            setStateComponent({
                openNewPost: true,
                post_id: tile.id,
                post_title: tile.title,
                post_message: tile.content,
                post_keywords: tile.keywords,
                post_image: tile.media_url,
                post_file: tile.file_url,
            });
        }*/

        //je veux faire un set state dans le composant parent








    };
    const handleOptionPostDelete = async (tile) => {
        handleOptionPostClose();
        //open delete post form
        console.log("handleOptionPostDelete");

        //send delete post request
        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }

        const body = new URLSearchParams({
            'contentId': dataPage.id,
            'socialPostId': tile.id, // ID du contenu
        });

        const response = await fetch(baseApiUrl + '/deleteSocialPost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },
            body: body

        });
        const data = await response.json();
        console.log("deleteSocialPost");
        console.log(data);
        console.log(data.success);
        if (!data.success) {
            throw new Error('Erreur lors de l\'envoi du post');
        }
        else {
            console.log("Post supprimé avec succès");

            let posts = fetchSocialPosts();

        }


    };
    const handleOptionPostReport = async () => {
        handleOptionPostClose();

        //confirmation
        if (!window.confirm("Êtes-vous sûr de vouloir signaler ce post ?")) {
            return;
        }

        //open report post form
        console.log("handleOptionPostReport");

        //send delete post request
        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }

        const body = new URLSearchParams({
            'contentId': dataPage.id,
            'socialPostId': tile.id, // ID du contenu
        });

        const response = await fetch(baseApiUrl + '/reportSocialPost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },
            body: body

        });
        const data = await response.json();
        console.log("deleteSocialPost");
        console.log(data);
        console.log(data.success);
        if (!data.success) {
            throw new Error('Erreur lors de l\'envoi du post');
        } else {
            console.log("Post supprimé avec succès");

            let posts = fetchSocialPosts();
        }

    };



    const [anchorCommentEl, setAnchorCommentEl] = useState(null);
    const [activeCommentIndex, setActiveCommentIndex] = useState(null)

    const handleMenuCommentOpen = (event, index) => {
        setAnchorCommentEl(event.currentTarget);
        setActiveCommentIndex(index);
    };

    const handleMenuCommentClose = () => {
        setAnchorCommentEl(null);
        setActiveCommentIndex(null);
    };

    ;

    const openMenuComment = Boolean(anchorCommentEl);
    const handleCommentPostClose = () => {
        setAnchorCommentEl(null);
    };

    const handleCommentPostEdit = async (comment) => {
        handleCommentPostClose();
        //open edit post form
        console.log("handleOptionPostEdit");

        setCommentText(comment.commentaire)
        setCommentId(comment.id);

    };
    const handleCommentPostDelete = async (tile, comment) => {
        handleCommentPostClose();
        //open delete post form
        console.log("handleOptionPostDelete");


        try {
            const response = await fetch(baseApiUrl + '/setInteractionForContentId', {
                method: 'POST', // Méthode POST
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': tile.id,
                    'type': 'deleteComment', // Type d'interaction
                    'value': null, // Valeur de l'interaction
                    'interactionId': comment.id // Valeur de l'interaction
                })
            });

            const data = await response.json();

            const responseComment = await fetch(baseApiUrl + '/getInteractionsByContentId', {
                method: 'POST', // Requête POST, comme dans le curl
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': tile.id, // ID du contenu
                    'offset': '0',
                    'limit': '100'
                })
            });

            const dataComment = await responseComment.json();

            if (!dataComment.success) {
                throw new Error('Erreur lors de la récupération des commentaires');
            }


            const comments = dataComment.result.comments;

            console.log(comments);

            setComments(comments); // Assurez-vous que `data` contient les commentaires sous la forme attendue
        } catch (error) {
            console.error('Erreur lors du chargement des commentaires:', error);
        }
    };
    const handleCommentPostReport = async (comment) => {
        handleCommentPostClose();
        //open report post form

        if (!window.confirm("Êtes-vous sûr de vouloir signaler ce commentaire ?")) {
            return;
        }

        console.log("handleOptionPostReport");


        try {
            const response = await fetch(baseApiUrl + '/setInteractionForContentId', {
                method: 'POST', // Méthode POST
                body: new URLSearchParams({
                    'appId': state.application.getApp.id,
                    'mobinauteId': parseInt(state.profil.mobinaute.id, 10),
                    'contentId': dataPage.id, // ID du contenu
                    'type': 'badComment', // Type d'interaction
                    'value': null, // Valeur de l'interaction
                    'interactionId': comment.id // Valeur de l'interaction
                })
            });

            const data = await response.json();

            //refresh posts
            let posts = fetchSocialPosts();

            if (!data.success) {
                throw new Error('Erreur lors du like');
            }
        } catch (error) {
            console.error('Erreur lors du chargement des commentaires:', error);
        }
    };




    return (
        <Card key={key} style={{ margin: "auto", borderRadius: 3, boxShadow: 3, marginTop: "30px", width: "100%", maxWidth: 800,  position: "relative" }}>
            {/* Bouton more option */}

            {/* Icône More options en haut à droite */}
            <IconButton
                aria-label="more options"
                style={{ position: "absolute", top: 10, right: 10, border : "none", outline: "none" }}
                onClick={(event) => {
                    setAnchorEl(event.currentTarget);
                }}
            >
                <FontAwesomeIcon icon={faEllipsisV} size={"sm"}/>
            </IconButton>
            <Menu anchorEl={anchorEl} open={openMenu} onClose={handleOptionPostClose}>
                {tile.author.id === state.profil.mobinaute.id &&
                    <MenuItem onClick={() => handleOptionPostEdit(tile)}>Modifier</MenuItem>
                }
                {tile.author.id === state.profil.mobinaute.id &&
                    <MenuItem onClick={() => handleOptionPostDelete(tile)}>Supprimer</MenuItem>
                }
                {tile.author.id !== state.profil.mobinaute.id &&
                    <MenuItem onClick={handleOptionPostReport}>Signaler</MenuItem>
                }
            </Menu>

            {/* Header */}
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "auto" }}>
                    <Avatar src={buildShapperPath(tile.author.profilMedia)} alt="Profile" sx={{ width: 56, height: 56, mr: 2 }} />
                    <div style={{ paddingLeft: 15 }}>
                        <Typography variant="h6" sx={{ mr: 1 }}>{prenomnom}</Typography>
                        <Typography variant="body2" color="textSecondary">{timeAgo}</Typography>
                        {/*{tile.keywords}*/}
                        <div style={{ display: "flex", flexWrap: "wrap", marginTop: 5 }}>
                            {tile.keywords && tile.keywords.split(',').filter(keyword => keyword.trim() !== '').map((keyword, index) => (
                                <Typography key={index} variant="body2" color="textSecondary" style={{ marginRight: 5, padding: 5, backgroundColor: "#e0e0e0", borderRadius: 5 }}>
                                    {keyword}
                                </Typography>
                            ))}
                        </div>
                    </div>
                </div>
            </CardContent>


            {/* Contenu */}

            <CardContent>
                {/* Titre et sous-titre */}
                <Typography variant="h5" gutterBottom>{tile.title}</Typography>

                {/* Texte de publication */}
                <Typography variant="body1" paragraph>
                    {!expanded && text.length > 200 ? text.substring(0, 200) + '...' : parserContent(textFormated)}
                </Typography>
                {!expanded && text.length > 200 && (
                    <Button onClick={() => setExpanded(true)} color="primary">Voir plus</Button>
                )}
            </CardContent>


            {/* Image d'illustration */}

            {tile.media_url &&
                <div style={{
                    maxHeight: 400,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    padding: 10
                }}>
                    <img
                        src={buildShapperPath(tile.media_url)}
                        alt="Illustration"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                            borderRadius: 3,
                            cursor: "pointer"
                        }}
                        onClick={handleImageClick}
                    />
                </div>
            }

            {tile.file_url &&
                //item fichier qui n'est pas une image et qui s'ouvre dans une nouvelle fenetre
                <IconButton
                    style={{ padding: 10, paddingLeft: 30, maxHeight: 400, cursor: "pointer", outline: "none", border: "none" }}
                    onClick={() => window.open(tile.file_url, '_blank')}
                >
                    <FontAwesomeIcon icon={faPaperclip} />
                    <Typography variant="body2" color="textSecondary" style={{ marginLeft: 10 }}>
                        Pièce jointe
                    </Typography>
                </IconButton>

            }

            <Divider />

            {/* Boutons */}
            <CardContent style={{ display: "flex", justifyContent: "space-around", padding: "4px" }}>
                <IconButton color="primary" style={{ outline: "none", border: "none" }}>
                    <FontAwesomeIcon onClick={handleLike} icon={tile.is_liked ? faThumbsUp : faThumbsDownRegular } />
                    <Typography className="ml-2" onClick={handleLike}>
                        J'aime
                    </Typography>
                    {/* Afficher le nombre de likes si > 0 */}
                    { tile.nb_likes > 0 &&
                        <Typography className="ml-2" onClick={handleShowLikes}>
                            ({tile.nb_likes})
                        </Typography>
                    }

                </IconButton>
                <IconButton color="primary" onClick={handleOpen} style={{ outline: "none", border: "none" }}>
                    <FontAwesomeIcon
                        icon={faComment}
                    />

                    <Typography className="ml-2">
                        Commentaires ({tile.nb_comments})
                    </Typography>
                </IconButton>
            </CardContent>
            {/* Section des commentaires */}
            {/* Popup de commentaires */}
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <IconButton
                    onClick={handleClose}
                    style={{ position: "absolute", top: 10, right: 10}}
                >
                    <FontAwesomeIcon icon={faWindowClose}/>
                </IconButton>
                <DialogTitle>Commentaires</DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                        <Avatar src={buildShapperPath(store.getState().profil.mobinaute.profilMedia)} alt="Profile" style={{ width: 40, height: 40, marginRight: 10 }} />
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Écrire un commentaire..."
                            value={commentText}
                            onChange={(e) => setCommentText(e.target.value)}
                            sx={{ marginLeft: 2 }}
                        />
                        <IconButton
                            color="primary"
                            onClick={() => handleSubmitComment(commentText)}
                            disabled={!commentText.trim()}
                            sx={{ marginLeft: 2 }}
                        >
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </IconButton>
                    </div>

                    {/*SCROLL*/}
                    <div style={{
                        maxHeight: 400,
                        overflowY: "auto",
                        padding: 10,
                    }}>

                        {/* Liste des commentaires */}
                        <List>
                            {comments.map((comment, index) => (
                                <ListItem key={index} alignItems="flex-start">
                                    <ListItemAvatar>
                                        <Avatar src={buildShapperPath(comment.profilMedia)} alt="Profile" />
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={comment.firstname + ' ' + comment.lastname}
                                        secondary={comment.commentaire}
                                    />
                                    <Typography variant="body2" color="textSecondary">
                                        {new Date(comment.createdAt).toLocaleDateString('fr-FR', {
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </Typography>

                                    {/* Icône More options en haut à droite */}
                                    <IconButton
                                        aria-label="more options"
                                        style={{ border : "none", outline: "none" }}
                                        onClick={(event) => handleMenuCommentOpen(event, index)}
                                    >
                                        <FontAwesomeIcon icon={faEllipsisV} size={"sm"} style={{ fontSize: "0.65rem" }}/>
                                    </IconButton>

                                    <Menu anchorEl={anchorCommentEl} open={activeCommentIndex === index && openMenuComment} onClose={handleMenuCommentClose}>
                                        {comment.mobinaute_id === state.profil.mobinaute.id &&
                                            <MenuItem onClick={() => handleCommentPostEdit(comment)}>Modifier</MenuItem>
                                        }
                                        {comment.mobinaute_id === state.profil.mobinaute.id &&
                                            <MenuItem onClick={() => handleCommentPostDelete(tile, comment)}>Supprimer</MenuItem>
                                        }
                                        {comment.mobinaute_id !== state.profil.mobinaute.id &&
                                            <MenuItem onClick={() => handleCommentPostReport(comment)}>Signaler</MenuItem>
                                        }
                                    </Menu>

                                </ListItem>
                            ))}
                        </List>

                    </div>

                </DialogContent>
            </Dialog>

            <Dialog open={openLikes} onClose={handleCloseLikes} fullWidth maxWidth="sm">
                <IconButton
                    onClick={handleCloseLikes}
                    style={{ position: "absolute", top: 10, right: 10}}
                >
                    <FontAwesomeIcon icon={faWindowClose}/>
                </IconButton>
                <DialogTitle>Réactions</DialogTitle>
                <DialogContent>
                    {/* Liste des commentaires */}
                    <List>
                        {reactions.map((react, index) => (
                            <ListItem key={index} alignItems="flex-start">
                                <ListItemAvatar>
                                    <Avatar src={buildShapperPath(react.profilMedia)} alt="Profile" />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={react.firstname + ' ' + react.lastname}
                                />

                                <Typography style={{fontSize: "2.5rem", marginLeft: 10, marginTop: 5}} variant="body2" color="textSecondary">
                                    {react.reaction}
                                </Typography>


                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
            </Dialog>

            <Dialog open={openFullImage} onClose={handleImageClose} maxWidth="lg">
                <DialogContent
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 20,
                    }}
                >
                    <img
                        src={tile.media_url ? buildShapperPath(tile.media_url) : ""}
                        alt="Illustration agrandie"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "80vh", // limite à la hauteur de la fenêtre
                            height: "auto",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: 4,
                        }}
                    />
                </DialogContent>
            </Dialog>
        </Card>
    );
}

class SocialFeed extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            posts: [],
            open: false,
            comments: [],
            reactions: [],
            commentText: '',
            like: '',
            selectedImage: null,
            selectedImageUrl: null,
            selectedAttachment: null,
            selectedAttachmentUrl: null,
            post_id: '',
            post_title: '',
            post_message: '',
            post_keywords: '',
            post_image: '',
            post_file: '',
            commentId: null,
            lastPostId: null,
        };
    }

    async componentDidMount() {
        let posts = await this.fetchSocialPosts();
    }

    handleUpdateFromChild = (newData) => {
        this.setState({ ...newData });
    };


    render() {
        const dyn_string = this.props.t

        //* Récupération de la liste des posts sociaux */
        //get posts state loaded in componentDidMount
        const { dataPage } = this.props;
        const posts = this.state.posts;

        const handleNewPost = async () => {
            console.log("handleNewPost");

            //open newPostForm dialog
            this.setState({
                openNewPost: true,
                post_id: '',
                post_title: '',
                post_message: '',
                post_keywords: '',
                post_image: '',
                post_file: '',
            });

        };

        const handleNewPostClose = () => {
            this.setState({openNewPost: false });
        }


        const avatarUrl = buildShapperPath(store.getState().profil.mobinaute.profilMedia);

        //bouton nouveau post
        const newPostButton = (
        <div style={{ display: "flex", alignItems: "center", marginBottom: 10, width: "100%",maxWidth: "800px", marginLeft: "auto", marginRight: "auto", marginTop: "20px", backgroundColor: "#f5f5f5", color: "#fff"
            , center: "center", justifyContent: "center", borderRadius: "5px", padding: "20px 20px" }} onClick={handleNewPost}>
            <Avatar alt="Profile" style={{ width: 40, height: 40, marginRight: 10 }} src={avatarUrl} />
            <TextField
                fullWidth
                variant="outlined"
                placeholder={dyn_string('g_label_message')}
                sx={{ marginLeft: 2 }}
            />
            <IconButton
                color="primary"
                disabled={true}
                sx={{ marginLeft: 2 }}
            >
                <FontAwesomeIcon icon={faPaperPlane} />
            </IconButton>
        </div>

        );

        const handleImageSelected = async (file) => {
            this.setState({selectedImage: file});
            console.log('Fichier image sélectionné:', file);
            // Tu pourrais ici l’envoyer vers un backend
            // go upload

            //si c'est un fichier on l'upload, si c'est une url on la met dans selectedImageUrl
            if (file && file.type) {
                const responseUploadMediaStatic = await uploadMediaStatic(file);
                console.log('responseUploadMediaStatic:', responseUploadMediaStatic);
                if (responseUploadMediaStatic.success) {
                    this.setState({selectedImageUrl: responseUploadMediaStatic.result.file_url});
                } else {
                    console.error('Erreur lors de l\'upload de l\'image:', responseUploadMediaStatic.error);
                }
            }
            else {
                this.setState({selectedImageUrl: file});
            }
        };

        const handleAttachmentSelected = async (file) => {
            this.setState({selectedAttachment: file});
            console.log('Fichier sélectionné:', file);
            // Tu pourrais ici l’envoyer vers un backend
            // go upload

            if (file && file.type) {
                const responseUploadMediaStatic = await uploadMediaStatic(file);
                console.log('responseUploadMediaStatic:', responseUploadMediaStatic);
                if (responseUploadMediaStatic.success) {
                    this.setState({selectedAttachmentUrl: responseUploadMediaStatic.result.file_url});
                } else {
                    console.error('Erreur lors de l\'upload de la pièce jointe:', responseUploadMediaStatic.error);
                }
            }
            else {
                this.setState({selectedAttachmentUrl: file});
            }
        };

        const newPostForm = (
            <Dialog open={this.state.openNewPost} onClose={handleNewPostClose} fullWidth maxWidth="sm">
                <IconButton
                    onClick={handleNewPostClose}
                    style={{ position: "absolute", top: 10, right: 10, color: "#3f51b5" }}
                >
                    <FontAwesomeIcon icon={faWindowClose} />
                </IconButton>
                <DialogTitle>{dyn_string('g_label_new_post')}</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        id="title"
                        label={dyn_string('g_label_title')}
                        rows={4}
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={this.state.post_title}
                        onChange={(e) => this.setState({ post_title: e.target.value })}
                    />

                    <TextField
                        margin="dense"
                        id="message"
                        label={dyn_string('g_label_content')}
                        multiline={true}
                        rows={4}
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={this.state.post_message}
                        onChange={(e) => this.setState({ post_message: e.target.value })}
                    />


                    {this.props.dataPage.keyword.split(',').map((keyword, index) => (
                        <Chip
                            key={index}
                            label={keyword.trim()}
                            color={this.state.post_keywords && this.state.post_keywords.includes(keyword.trim() + ',') ? 'primary' : 'default'}
                            onDelete={() => {
                                // Handle keyword delete if needed
                                console.log(`Keyword deleted: ${keyword}`);
                                //remove
                                this.setState({ post_keywords: this.state.post_keywords.replace(keyword.trim() + ',', '') });
                            }}
                            onClick={() => {
                                // Handle keyword click if needed
                                console.log(`Keyword clicked: ${keyword}`);
                                if (!this.state.post_keywords || !this.state.post_keywords.includes(keyword.trim() + ',')) {
                                    this.setState({post_keywords: this.state.post_keywords? this.state.post_keywords + keyword.trim() + ',' : keyword.trim() + ','});
                                }

                            }}
                            style={{ margin: '5px' }}
                        />
                    ))}

                    <TextField
                        margin="dense"
                        id="keywords"
                        label={dyn_string('g_label_keywords')}
                        rows={4}
                        style={{ display: 'none' }}
                        fullWidth
                        variant="outlined"
                        placeholder={dyn_string('g_label_keywords_placeholder')}
                        disabled={true}
                        value={this.state.post_keywords}
                        onChange={(e) => this.setState({ post_keywords: e.target.value })}
                    />

                    <div style={{ display: "flex", justifyContent: "left", marginTop: "20px" }}>
                        <div>
                            <ImageUploader onImageSelected={handleImageSelected} defaultValue={this.state.post_image} />
                        </div>
                        <div style={{ marginLeft: "20px" }}>
                            <AttachmentUploader onAttachmentSelected={handleAttachmentSelected} defaultValue={this.state.post_file}/>
                        </div>
                    </div>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            //handleNewPost
                            const id = this.state.post_id;
                            const title = document.getElementById("title").value;
                            const message = document.getElementById("message").value;
                            const keywords = document.getElementById("keywords").value;
                            const image = this.state.selectedImageUrl || null;
                            const attachment = this.state.selectedAttachmentUrl || null;

                            //call uploadMediaStatic webservice

                            await this.handleNewPost({
                                socialPostId: id,
                                title: title,
                                message: message,
                                image: image,
                                fileUrl: attachment,
                                keywords: keywords,
                            });

                            //refresh posts
                            let posts = await this.fetchSocialPosts().then(
                                (response) => {
                                    console.log("response");
                                    console.log(response);

                                    this.setState({ posts: response });

                                    return response;
                                }
                            ).catch((error) => {
                                console.error('Erreur lors de la récupération des posts:', error);
                            });



                            this.setState({ openNewPost: false });
                        }}
                        style={{ marginTop: "20px", width: "100%", maxWidth: "800px", marginLeft: "auto", marginRight: "auto", backgroundColor: "#3f51b5", color: "#fff"
                            , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                    >
                        {dyn_string('g_label_post')}
                    </Button>
                </DialogContent>
            </Dialog>
        );

        const setStateComponent = async (state) => {
            this.setState(state);
        };

        if (isResponsive()) {
            return (
                <div>
                    <BreadCrumbs id={this.props.dataPage.id} style={{marginBottom: "20px"}}/>
                    {newPostButton}
                    <div>
                        {/*BTN REFRESH*/}
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={async () => {
                                    let posts = await this.fetchSocialPosts().then(
                                        (response) => {
                                            console.log("response");
                                            console.log(response);

                                            this.setState({ posts: response });

                                            return response;
                                        }
                                    ).catch((error) => {
                                        console.error('Erreur lors de la récupération des posts:', error);
                                    });
                                }}
                                style={{ width: "100%", maxWidth: "800px", backgroundColor: "#3f51b5", color: "#fff"
                                    , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                            >
                                {dyn_string('g_label_refresh')}
                            </Button>

                        </div>
                    </div>
                    {newPostForm}
                <ul style={{
                    padding: 0,
                    listStyle: "none",
                    gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
                    paddingInlineStart: "20px",
                    paddingInlineEnd: "20px"
                }}>
                    <FlatList
                        list={posts}
                        renderItem={this.renderCategory}
                        renderWhenEmpty={() => <h4
                            style={{marginTop: "70px", textAlign: "center"}}>{dyn_string('g_label_no_result')}</h4>}
                        display={{
                            grid: false,
                            gridGap: "20px",
                        }}
                        style={{listStyle: "none", backgroundColor: '#ffffff', marginTop: "20px", padding: 0}}
                    />
                    {posts.length > 0 &&
                        <div style={{marginTop: "20px", textAlign: "center"}}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={async () => {
                                    let posts = await this.fetchSocialPosts(this.state.lastPostId).then(
                                        (response) => {
                                            console.log("response");
                                            console.log(response);

                                            return response;
                                        }
                                    ).catch((error) => {
                                        console.error('Erreur lors de la récupération des posts:', error);
                                    });

                                    let allPosts = [...this.state.posts, ...posts];
                                    console.log("allPosts");
                                    console.log(allPosts);
                                    this.setState({ posts: allPosts });
                                }}
                                style={{ width: "100%", maxWidth: "800px", marginLeft: "auto", marginRight: "auto", backgroundColor: "#3f51b5", color: "#fff"
                                    , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                            >
                                {dyn_string('g_label_load_more')}
                            </Button>
                        </div>
                    }
                </ul>
                </div>
            );
        }
        else {
            return (
                <div>
                    <BreadCrumbs id={this.props.dataPage.id} style={{marginBottom: "20px"}}/>
                    {newPostButton}
                    <div>
                        {/*BTN REFRESH*/}
                        <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={async () => {
                                    let posts = await this.fetchSocialPosts().then(
                                        (response) => {
                                            console.log("response");
                                            console.log(response);

                                            this.setState({ posts: response });

                                            return response;
                                        }
                                    ).catch((error) => {
                                        console.error('Erreur lors de la récupération des posts:', error);
                                    });
                                }}
                                style={{ width: "100%", maxWidth: "800px", backgroundColor: "#3f51b5", color: "#fff"
                                    , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                            >
                                {dyn_string('g_label_refresh')}
                            </Button>

                        </div>
                    </div>
                    {newPostForm}
                    <ul style={{
                        gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
                        paddingInlineStart: "20px",
                        paddingInlineEnd: "20px"
                    }}>
                        <FlatList
                            list={posts}
                            renderItem={this.renderCategory}
                            renderWhenEmpty={() => <h4
                                style={{marginTop: "70px", textAlign: "center", backgroundColor: '#ffffff'}}>{dyn_string('g_label_no_result')}</h4>}
                            display={{
                                grid: false,
                                gridGap: "40px",
                            }}
                        />
                    </ul>
                    {posts.length > 0 &&
                        <div style={{marginTop: "20px", textAlign: "center"}}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={async () => {
                                    let posts = await this.fetchSocialPosts(this.state.lastPostId).then(
                                        (response) => {
                                            console.log("response");
                                            console.log(response);

                                            return response;
                                        }
                                    ).catch((error) => {
                                        console.error('Erreur lors de la récupération des posts:', error);
                                    });


                                    let allPosts = [...this.state.posts, ...posts];
                                    console.log("allPosts");
                                    console.log(allPosts);
                                    this.setState({ posts: allPosts });
                                }}
                                style={{ width: "100%", maxWidth: "800px", marginLeft: "auto", marginRight: "auto", backgroundColor: "#3f51b5", color: "#fff"
                                    , center: "center", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "5px", padding: "10px 20px" }}
                            >
                                {dyn_string('g_label_load_more')}
                            </Button>
                        </div>
                    }
                </div>
            );
        }
    }

    renderCategory = (tile, key) => {
        return <PostItem tile={tile} key={key} dataPage={this.props.dataPage} fetchSocialPosts={this.fetchSocialPosts} handleNewPost={this.handleNewPost} handleLike={this.handleLike} handleOpen={this.handleOpen} handleClose={this.handleClose} handleShowLikes={this.handleShowLikes} onUpdateState={this.handleUpdateFromChild}/>
    }

    fetchSocialPosts = async (lastPostIdp) => {
        const state = store.getState();

        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }


        let searchParams = {
            'contentId': this.props.dataPage.id,
        };

        if (lastPostIdp) {
            searchParams.lastPostId = lastPostIdp;
        }

        const response = await fetch(baseApiUrl + '/getSocialPosts', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },

            body: new URLSearchParams(searchParams)
        });

        const data = await response.json();

        console.log("getSocialPosts");

        console.log(data);

        console.log(data.success);

        console.log(data.result);

        if (!data.success) {
            throw new Error('Erreur lors de la récupération des posts');
        }




        if(!data.result || data.result.length === 0) {
            console.log("Aucun post trouvé");

            this.setState({ posts: data.result });

            return [];
        }
        else {
            let lastId = data.result[data.result.length - 1].id;

            this.setState({ lastPostId: lastId });

            this.setState({ posts: data.result });

            return data.result;
        }

    };

    handleNewPost = async (post) => {
        console.log("handleNewPost");
        console.log(post);
        //send post to api
        const state = store.getState();

        let token = '';
        if (typeof state.profil.mobinaute.accounts !== 'undefined' && typeof state.profil.mobinaute.accounts.shapper_token !== 'undefined') {
            token = state.profil.mobinaute.accounts.shapper_token.access_token;
        } else if (typeof state.application.deviceToken !== 'undefined') {
            token = state.application.deviceToken.access_token;
        }

        let body = new URLSearchParams({
            'contentId': this.props.dataPage.id,
            'title': post.title,
            'content': post.message
        });

        if (post.socialPostId) {
            body.append('socialPostId', post.socialPostId);
        }

        if (post.image) {
            body.append('mediaUrl', post.image);
        }

        if (post.fileUrl) {
            body.append('fileUrl', post.fileUrl);
        }

        if (post.keywords) {
            body.append('keywords', post.keywords);
        }

        const response = await fetch(baseApiUrl + '/sendSocialPost', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${token}`,
            },
            body: body

        });
        const data = await response.json();
        console.log("sendSocialPost");
        console.log(data);
        console.log(data.success);
        if (!data.success) {
            throw new Error('Erreur lors de l\'envoi du post');
        }
        else {
            console.log("Post envoyé avec succès");
            this.setState({selectedImage: null, selectedImageUrl: null});
            this.setState({selectedAttachment: null, selectedAttachmentUrl: null});
        }
        return data.result || [];

    }
}

// send form new post



const mapStateToProps = (props) => ({
    styles: props.style,
    posts: props.posts || [],

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {},
        dispatch
    );

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps()))(SocialFeed);
